module.exports = "query DueTodayIssuesCountQuery{dueToday:issues(closedAt_Isnull:true,dueToday:true){totalCount hasUnreadMessages}}"